var React = require('react');

function CalendarMinus (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8","key":0}),React.createElement("line",{"x1":"16","y1":"2","x2":"16","y2":"6","key":1}),React.createElement("line",{"x1":"8","y1":"2","x2":"8","y2":"6","key":2}),React.createElement("line",{"x1":"3","y1":"10","x2":"21","y2":"10","key":3}),React.createElement("line",{"x1":"16","y1":"19","x2":"22","y2":"19","key":4})]);
}

CalendarMinus.defaultProps = {"width":"32","height":"32","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"calendar-minus"};

module.exports = CalendarMinus;

CalendarMinus.default = CalendarMinus;
